<template>
  <div>
    <el-card shadow="always">
      <div slot="header" class="clearfix">
        <el-col :lg="8">
          {{ $t("cadastro-template-notificacao") }}
        </el-col>
      </div>
      <el-row type="flex" justify="end">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="userType === '1' || userType === '3'">
          <CustomerList v-model="customer" v-bind:customerType="userType === '2' ? 3 : 1" v-bind:current="customer"
            @selected="change" />
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button class="right" type="primary" icon="el-icon-plus" @click="add()">{{ $t("customizar") }}</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" stripe style="width: 100%" :default-sort="{ prop: 'name', order: 'ascending' }">
        <el-table-column sortable prop="description" :label="$t('tipo')">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.customerId">Customizado</el-tag>
            <el-tag v-else>Padrão</el-tag>
          </template>
        </el-table-column>
        <el-table-column sortable prop="description" :label="$t('evento')"></el-table-column>
        <el-table-column sortable prop="template" :label="$t('mensagem')"></el-table-column>
        <el-table-column sortable prop="createdAt" :label="$t('data-criacao')"></el-table-column>
        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button v-if="userType === '1' || customer === scope.row.customerId" type="danger" icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.description)" circle></el-button>
            <el-button v-if="userType === '1' || customer === scope.row.customerId" type="primary" title="Histórico"
              icon="el-icon-tickets" @click="editar(scope.$index, scope.row)" circle></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { NotificationTemplateService } from "@/services/customers/template.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";

export default {
  name: "Packing",
  components: {
    CustomerList,
  },
  computed: {
    filters() {
      const vm = this;
      const list = [];
      for (const row of vm.tableData) {
        const record = row.customer ? row.customer : "Padrão";
        if (!list.find((x) => x.value === record)) {
          list.push({
            text: record,
            value: record,
          });
        }
      }
      return list.sort(function (a, b) {
        if (a.text.toUpperCase() > b.text.toUpperCase()) return 1;
        if (a.text.toUpperCase() < b.text.toUpperCase()) return -1;
        return 0;
      });
    },
  },
  methods: {
    filterHandler(value, row, column) {
      const property = column["property"];
      if (row[property]) {
        return row[property] === value;
      } else {
        return value === "Padrão";
      }
    },
    change(customer) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      NotificationTemplateService.list(customer)
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      NotificationTemplateService.list()
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      var vm = this;
      vm.$router.replace({
        name: "notification.template.add",
      });
    },
    editar: function (id) {
      this.$router.replace({
        name: "notification.template.add",
        params: { id: id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-template", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        NotificationTemplateService.delete(id)
          .then((response) => {
            this.$message({
              type: "success",
              message: i18n.tc("template-eliminado-sucesso"),
            });
            vm.tableData.splice(
              vm.tableData.findIndex((x) => x.id === id),
              1
            );
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.customer = response.customers ? response.customers.id : null,
          vm.userType = response.type;
        vm.fetch();
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      filter: "",
      userType: "2",
      customer: null,
      tableData: [],
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>